import { render, staticRenderFns } from "./call-icon.vue?vue&type=template&id=8c45b768"
import script from "./call-icon.vue?vue&type=script&lang=js"
export * from "./call-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c45b768')) {
      api.createRecord('8c45b768', component.options)
    } else {
      api.reload('8c45b768', component.options)
    }
    module.hot.accept("./call-icon.vue?vue&type=template&id=8c45b768", function () {
      api.rerender('8c45b768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/notifications/call-icon.vue"
export default component.exports